import React from 'react';
import CollectionItemPropertySelect from './CollectionItemPropertySelect';
import { useCollectionProperties, useModifyCollectionProperties } from '../RealtimeCollectionProvider';
import { useCollectionPropertiesOrder } from '@/hooks/TableHooks';

const CollectionItemPropertiesList = ({
    collectionId,
    itemId,
    canEdit,
}: {
    collectionId: string;
    itemId: string;
    canEdit: boolean;
}) => {
    const { properties } = useCollectionProperties(collectionId);

    const collection = React.useMemo(
        () => ({
            id: collectionId,
            extendedProperties: properties ?? [],
        }),
        [collectionId, properties],
    );

    const [propertiesOrder] = useCollectionPropertiesOrder(collection);
    const { setValueForDocumentProperty } = useModifyCollectionProperties(collectionId);

    return properties ? (
        <React.Fragment key={collectionId}>
            {propertiesOrder.folderViewProperties.map((propertyId) => {
                const property = properties.find((p) => p.id === propertyId);
                if (!property) {
                    return null;
                }
                return (
                    <React.Fragment key={propertyId}>
                        <div className="text-saga-gray-500">{property.title}</div>
                        <div className="flex items-center min-h-8">
                            <div className="ml-1 w-full">
                                <CollectionItemPropertySelect
                                    property={{
                                        id: property.id,
                                        title: property.title,
                                        type: property.type,
                                        value: property.values[itemId],
                                    }}
                                    onChange={(value) => {
                                        setValueForDocumentProperty(itemId, property.id, value);
                                    }}
                                    showEmptyState={canEdit}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                );
            })}
        </React.Fragment>
    ) : null;
};

export default CollectionItemPropertiesList;
